import React, { Dispatch, SetStateAction } from 'react';
import {
  CustomField,
  FIELD_TYPE,
  AssignedCustomField,
} from 'admin/customFields/entities/customFields.entity';
import Grid from '@mui/material/Grid';
import { Tooltip } from 'common/components/Tooltip/Tooltip';
import { CustomFieldInput } from './CustomFieldInput';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export type CustomFieldsEditProps = {
  setChanges: (changes: boolean) => void;
  customFieldsData?: CustomField[];
  assignedCustomFields: AssignedCustomField[];
  setAssignedCustomFields: Dispatch<SetStateAction<AssignedCustomField[]>>;
};

const TypographyStyled = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(16),
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}));

export const CustomFieldsEdit = React.memo(
  ({
    setChanges,
    customFieldsData = [],
    assignedCustomFields,
    setAssignedCustomFields,
  }: CustomFieldsEditProps) => {
    return (
      <>
        {customFieldsData.map((field: CustomField) => {
          const index = assignedCustomFields.findIndex((f) => f.label === field.label);
          return (
            <React.Fragment key={field.id}>
              <Grid
                size={4}
                sx={{
                  display: 'flex',
                  alignItems: field.dataType === FIELD_TYPE.Text ? 'flex-start' : 'center',
                  ...(field.dataType === FIELD_TYPE.Text ? { paddingTop: '10 !important' } : {}),
                }}
              >
                <Tooltip title={field.label}>
                  <TypographyStyled variant="text2" color="text.secondary">
                    {field.label}
                  </TypographyStyled>
                </Tooltip>
              </Grid>
              <Grid size={8}>
                <CustomFieldInput
                  field={field}
                  fieldIndex={index}
                  setChanges={setChanges}
                  assignedCustomFields={assignedCustomFields}
                  setAssignedCustomFields={setAssignedCustomFields}
                />
              </Grid>
            </React.Fragment>
          );
        })}
      </>
    );
  },
);
